import * as React from 'react';
// @ts-ignore
import AdminUpgradePageHeader from 'admin/components/AdminUpgradePageHeader';
import ScheduledMaintenancePage from 'app/components/ScheduledMaintenancePage';
import Link from 'components/Link';
import LinkConstants from 'constants/LinkConstants';

import './styles/AdminUpgradeScheduledMaintenance.scss';

export default function AdminUpgradeScheduledMaintanencePage() {
  return (
    <div className="AdminUpgradeScheduledMaintanence">
      <AdminUpgradePageHeader
        title="The Remind plan for schools and districts"
        hideHelp
        hideClose
      />
      <ScheduledMaintenancePage
        className="AdminUpgradeScheduledMaintanence-content"
        subtext="Check back again soon. If you'd like to get in touch with our sales team now, feel free to reach out"
        contactUsRoute={LinkConstants.ADMIN_UPGRADE_FORM}
      />
    </div>
  );
}
